import React, { Component } from "react";
import ImageWithFallback from "./ImageWithFallback";
export default class CarImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      image: null,
      isloaded: false,
    };
  }
  componentDidMount() {}
  componentDidUpdate(prevProps, prevState) {}
  setIsLoaded = () => {
    this.setState({
      isloaded: true,
    });
  };

  // Usage

  render() {
    const { data } = this.props;
    const notInSpecialOffers = ["PO86289", "PO86290", "PO86291"]; // Example array of komnr values that are not in special offers

    return (
      <>
        <div className="carImage">
          <ImageWithFallback
            key={`${data.komnr}-${data.model}`}
            src={data.img}
            fallbackUrls={[
              `./assets/models/${data.komnr}.avif`, // Second try local URL
              `./assets/placeholder/${data.model}_siluett.jpg`, // Third try placeholder
            ]}
            alt={data.kirjeldus}
            className="currentImage"
            lastFallbackClassName="currentImage placeholder-image"
          />
        </div>
        {!notInSpecialOffers.includes(data.komnr) ? (
          <img
            className="badge"
            src="./assets/images/suvepakett_redbg.svg"
            alt="suvepakett"
          />
        ) : (
          <img
            className="badge"
            src="./assets/images/parimhind_redbg.svg"
            alt="parimhind"
          />
        )}
      </>
    );
  }
}

/*

  {data.staatus === "Laos" && data.model === "Cayenne" ? (
          <img
            className="badge"
            src="./assets/images/suvepakett_redbg.svg"
            alt="suvepakett"
          />
        ) : (
          <img className="badge" src="./assets/images/laos.svg" alt="laos" />
        )}

*/
